import React from 'react';
import { Row, Col, Form, InputNumber, Checkbox } from 'antd';
import { CheckboxGroup } from 'common/components/input';
import { WEEK_DAY } from 'static/Constants';
import { SCHEDULE_FORM_LAYOUT } from 'common/components/modal-download-folder/constants';
const ReportingDownloadScheduleWeekSetting = () => {
  return (
    <>
      <Row wrap={false}>
        <Col span={8}>
          <Form.Item
            {...SCHEDULE_FORM_LAYOUT}
            name='runsPerWeek'
            label={'Every'}
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
          >
            <InputNumber min={0} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label={'weeks'} />
        </Col>
      </Row>
      <Row>
        <Row>
          <Col span={20}>
            <Form.Item
              {...SCHEDULE_FORM_LAYOUT}
              name='onDaysOfWeek'
              label='On'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <CheckboxGroup
                column={2}
                options={WEEK_DAY}
                style={{ width: '100%' }}
                renderItem={(option) => (
                  <Checkbox value={option} key={option}>
                    {option}
                  </Checkbox>
                )}
              ></CheckboxGroup>
            </Form.Item>
          </Col>
        </Row>
      </Row>
    </>
  );
};
export default ReportingDownloadScheduleWeekSetting;